/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import { goBack } from 'connected-react-router'
import addCadreActions, {
    addCadreTypes,
} from '../../../redux/cadre/addCadre'
import getAllCadresActions from '../../../redux/cadre/getAllCadres'
import alertActions from '../../../redux/alert'
import { Post } from '../../../serveur/axios'

function* addCadreSagas({ response }) {
    try {
        const res = yield Post('cadredirection/', response)
        if (res.status === 200 || res.status === 201) {
            yield all([
                yield put(addCadreActions.addCadreSuccess(res.data)),
                yield put(
                    alertActions.alertShow(true, {
                        onConfirm: false,
                        warning: false,
                        info: false,
                        error: false,
                        success: true,
                        message: response.intl.formatMessage({
                            id: 'successSagaMessage',
                        }),
                        title: response.intl.formatMessage({
                            id: 'successSagaTitle',
                        }),
                    })
                ),
                yield put(goBack()),
                yield put(addCadreActions.addCadreSuccess(null)),
                yield put(
                    getAllCadresActions.getAllCadresRequest()
                ),
            ])
        } else {
            yield put(addCadreActions.addCadreFailure(res))
        }
    } catch (error) {
        yield put(addCadreActions.addCadreFailure(error))
    }
}

export function* addCadreSaga() {
    yield takeLatest(
        addCadreTypes.ADD_CADRE_REQUEST,
        addCadreSagas
    )
}
